import type { ConditionFunctionConfig } from "@smartsuite/automation-engine-api";

/** An empty condition function of the given config kind, ready for its value to
 * be filled in. "Changes" is the one with structure of its own: it compares a
 * before and an after, each defaulting to "Any". */
export const getSelectedFunction = (value: string): ConditionFunctionConfig => {
  switch (value) {
    case "isEquals":
      return {
        function: {
          oneofKind: "isEquals",
          isEquals: {},
        },
      };
    case "isNotEquals":
      return {
        function: {
          oneofKind: "isNotEquals",
          isNotEquals: {},
        },
      };
    case "isAnyOf":
      return {
        function: {
          oneofKind: "isAnyOf",
          isAnyOf: {},
        },
      };
    case "isNoneOf":
      return {
        function: {
          oneofKind: "isNoneOf",
          isNoneOf: {},
        },
      };
    case "isEmpty":
      return {
        function: {
          oneofKind: "isEmpty",
          isEmpty: {},
        },
      };
    case "isNotEmpty":
      return {
        function: {
          oneofKind: "isNotEmpty",
          isNotEmpty: {},
        },
      };
    case "isAny":
      return {
        function: {
          oneofKind: "isAny",
          isAny: {},
        },
      };
    case "hasAnyOf":
      return {
        function: {
          oneofKind: "hasAnyOf",
          hasAnyOf: {},
        },
      };
    case "hasAllOf":
      return {
        function: {
          oneofKind: "hasAllOf",
          hasAllOf: {},
        },
      };
    case "hasNoneOf":
      return {
        function: {
          oneofKind: "hasNoneOf",
          hasNoneOf: {},
        },
      };
    case "greaterThan":
      return {
        function: {
          oneofKind: "greaterThan",
          greaterThan: {},
        },
      };
    case "greaterThanOrEquals":
      return {
        function: {
          oneofKind: "greaterThanOrEquals",
          greaterThanOrEquals: {},
        },
      };
    case "lessThan":
      return {
        function: {
          oneofKind: "lessThan",
          lessThan: {},
        },
      };
    case "lessThanOrEquals":
      return {
        function: {
          oneofKind: "lessThanOrEquals",
          lessThanOrEquals: {},
        },
      };
    case "between":
      return {
        function: {
          oneofKind: "between",
          between: {},
        },
      };
    case "betweenOrEquals":
      return {
        function: {
          oneofKind: "betweenOrEquals",
          betweenOrEquals: {},
        },
      };
    case "contains":
      return {
        function: {
          oneofKind: "contains",
          contains: {},
        },
      };
    case "notContains":
      return {
        function: {
          oneofKind: "notContains",
          notContains: {},
        },
      };
    case "changes":
      return {
        function: {
          oneofKind: "changes",
          changes: {
            before: {
              function: {
                oneofKind: "isAny",
                isAny: {},
              },
            },
            after: {
              function: {
                oneofKind: "isAny",
                isAny: {},
              },
            },
          },
        },
      };
    case "allItemsResolved":
      return {
        function: {
          oneofKind: "allItemsResolved",
          allItemsResolved: {},
        },
      };
    case "notAllItemsResolved":
      return {
        function: {
          oneofKind: "notAllItemsResolved",
          notAllItemsResolved: {},
        },
      };
    case "percentCompleteGreaterThan":
      return {
        function: {
          oneofKind: "percentCompleteGreaterThan",
          percentCompleteGreaterThan: {},
        },
      };
    case "percentCompleteLessThan":
      return {
        function: {
          oneofKind: "percentCompleteLessThan",
          percentCompleteLessThan: {},
        },
      };
    case "isComplete":
      return {
        function: {
          oneofKind: "isComplete",
          isComplete: {},
        },
      };
    case "isNotComplete":
      return {
        function: {
          oneofKind: "isNotComplete",
          isNotComplete: {},
        },
      };
    default:
      return {
        function: {
          oneofKind: undefined,
        },
      };
  }
};
